"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _QuizTournamentEndScreen = _interopRequireDefault(require("./QuizTournamentEndScreen.scss"));

var _index = _interopRequireDefault(require("../Button/index.js"));

var _NavigationManager = _interopRequireDefault(require("../../NavigationManager"));

var _QuizTournament = _interopRequireDefault(require("./QuizTournament"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _QuizTournamentStrings = require("./QuizTournamentStrings");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var QuizTournamentEndScreen = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(QuizTournamentEndScreen, _React$Component);

  var _super = _createSuper(QuizTournamentEndScreen);

  function QuizTournamentEndScreen(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, QuizTournamentEndScreen);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "leaveTournament", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _QuizTournament["default"].resetTournamentData();

            case 2:
              _NavigationManager["default"].goHome();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "draw", function () {
      var W = _this.canvas.clientWidth;
      var H = _this.canvas.clientHeight;
      _this.context = _this.canvas.getContext('2d');
      var results = []; // Magical recursive functional love

      requestAnimationFrame(_this.draw);

      _this.context.clearRect(0, 0, W, H);

      for (var i = 0; i < _this.maxConfettis; i++) {
        results.push(_this.particles[i].draw());
      }

      var particle = {};
      var remainingFlakes = 0;

      for (var _i = 0; _i < _this.maxConfettis; _i++) {
        particle = _this.particles[_i];
        particle.tiltAngle += particle.tiltAngleIncremental;
        particle.y += (Math.cos(particle.d) + 3 + particle.r / 2) / 2;
        particle.tilt = Math.sin(particle.tiltAngle - _i / 3) * 15;
        if (particle.y <= H) remainingFlakes++; // If a confetti has fluttered out of view,
        // bring it back to above the viewport and let if re-fall.

        if (particle.x > W + 30 || particle.x < -30 || particle.y > H) {
          particle.x = Math.random() * W;
          particle.y = -30;
          particle.tilt = Math.floor(Math.random() * 10) - 20;
        }
      }

      return results;
    });
    _this.possibleColors = ['DodgerBlue', 'OliveDrab', 'Gold', 'Pink', 'SlateBlue', 'LightBlue', 'Gold', 'Violet', 'PaleGreen', 'SteelBlue', 'SandyBrown', 'Chocolate', 'Crimson'];
    _this.maxConfettis = 100;
    _this.particles = [];
    return _this;
  }

  (0, _createClass2["default"])(QuizTournamentEndScreen, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var canvas = document.getElementById('confettiCanvas');

      if (canvas) {
        this.canvas = canvas;
        this.canvas.width = this.canvas.clientWidth;
        this.canvas.height = this.canvas.clientHeight;
        var context = this.canvas.getContext('2d');

        for (var i = 0; i < this.maxConfettis; i++) {
          this.particles.push(new ConfettiParticle(context, this.canvas.clientWidth, this.canvas.clientHeight, this.maxConfettis, this.possibleColors));
        }

        this.draw();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.tournament || !this.props.myTeamName) {
        return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null);
      }

      var teams = (0, _values["default"])(this.props.tournament['teams']);
      var team1 = teams[0];
      var team2 = teams[1];
      var winner = team1.points === team2.points ? false : team1.points > team2.points ? team1 : team2;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTournamentEndScreen["default"].mainWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTournamentEndScreen["default"].contentWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTournamentEndScreen["default"].winnerHeading
      }, winner ? "Team ".concat(winner.name, " hat gewonnen!") : (0, _QuizTournamentStrings.getString)('TIE_NOBREAK')), /*#__PURE__*/_react["default"].createElement("table", {
        className: _QuizTournamentEndScreen["default"].scoreTable
      }, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        style: {
          width: '45%',
          padding: '10px'
        }
      }, "Team ".concat(team1.name)), /*#__PURE__*/_react["default"].createElement("td", {
        style: {
          width: '10%',
          padding: '10px'
        }
      }), /*#__PURE__*/_react["default"].createElement("td", {
        style: {
          width: '45%',
          padding: '10px'
        }
      }, "Team ".concat(team2.name))), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTournamentEndScreen["default"].teamPointsContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTournamentEndScreen["default"].teamPoints
      }, team1.points))), /*#__PURE__*/_react["default"].createElement("td", null, ":"), /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTournamentEndScreen["default"].teamPointsContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTournamentEndScreen["default"].teamPoints
      }, team2.points))))), /*#__PURE__*/_react["default"].createElement(_index["default"], {
        className: _QuizTournamentEndScreen["default"].leaveBtn,
        theme: 'dark',
        onClick: this.leaveTournament
      }, (0, _QuizTournamentStrings.getString)('TOURNAMENT_LEAVE'))), (winner && this.props.myTeamName === winner.name || !winner) && /*#__PURE__*/_react["default"].createElement("canvas", {
        id: 'confettiCanvas',
        className: _QuizTournamentEndScreen["default"].confetti
      }));
    }
  }]);
  return QuizTournamentEndScreen;
}(_react["default"].Component);

var ConfettiParticle = /*#__PURE__*/function () {
  function ConfettiParticle(context, W, H, maxConfettis, possibleColors) {
    (0, _classCallCheck2["default"])(this, ConfettiParticle);
    this.context = context;
    this.x = Math.random() * W; // x

    this.y = Math.random() * H - H; // y

    this.r = this.randomFromTo(11, 33); // radius

    this.d = Math.random() * maxConfettis + 11;
    this.color = possibleColors[Math.floor(Math.random() * possibleColors.length)];
    this.tilt = Math.floor(Math.random() * 33) - 11;
    this.tiltAngleIncremental = Math.random() * 0.07 + 0.05;
    this.tiltAngle = 0;
  }

  (0, _createClass2["default"])(ConfettiParticle, [{
    key: "randomFromTo",
    value: function randomFromTo(from, to) {
      return Math.floor(Math.random() * (to - from + 1) + from);
    }
  }, {
    key: "draw",
    value: function draw() {
      this.context.beginPath();
      this.context.lineWidth = this.r / 2;
      this.context.strokeStyle = this.color;
      this.context.moveTo(this.x + this.tilt + this.r / 3, this.y);
      this.context.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 5);
      return this.context.stroke();
    }
  }]);
  return ConfettiParticle;
}();

var _default = QuizTournamentEndScreen;
exports["default"] = _default;